function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import debounce from '../../utils/debounce';
export default function withDebounceValue(_ref) {
  var _this = this;
  var options = _ref.options,
    _ref$wait = _ref.wait,
    wait = _ref$wait === void 0 ? 500 : _ref$wait;
  return function (Component) {
    return function (props) {
      var value = props.value,
        onBlur = props.onBlur,
        onChange = props.onChange,
        rest = _objectWithoutProperties(props, ["value", "onBlur", "onChange"]);
      var _useState = useState(value),
        _useState2 = _slicedToArray(_useState, 2),
        childValue = _useState2[0],
        setChildValue = _useState2[1];
      useEffect(function () {
        return setChildValue(value);
      }, [value]);
      var valueRef = useRef();
      valueRef.current = {
        value: value,
        childValue: childValue,
        onChange: onChange
      };
      var debounceChange = useMemo(function () {
        return debounce(function (val) {
          var _valueRef$current = valueRef.current,
            value = _valueRef$current.value,
            childValue = _valueRef$current.childValue,
            onChange = _valueRef$current.onChange; // Skip "commit" if value has been "committed" onBlur
          if (value !== childValue) {
            onChange(val);
          }
        }, wait, options);
      }, [valueRef]);
      var handleChange = useCallback(function (val) {
        setChildValue(val);
        debounceChange(val);
      }, [setChildValue, debounceChange]);

      // "Commit" childValue on blur so debounce doesn't fire after another field is changed
      var handleBlur = useCallback(function () {
        setTimeout(function () {
          return onChange(childValue);
        }, 1);
        onBlur.apply(this, arguments);
      }.bind(_this), [onBlur, onChange, childValue]);
      return /*#__PURE__*/React.createElement(Component, Object.assign({
        value: childValue,
        onBlur: handleBlur,
        onChange: handleChange
      }, rest));
    };
  };
}